import { render } from "./AppSvg.vue?vue&type=template&id=b293ecba&scoped=true"
import script from "./AppSvg.vue?vue&type=script&lang=js"
export * from "./AppSvg.vue?vue&type=script&lang=js"

import "./AppSvg.vue?vue&type=style&index=0&id=b293ecba&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b293ecba"]])

export default __exports__